import {AudioManager, AudioType} from '@colonist/audio'
import {UIChatPostController} from './UIChatPostController'
import {FeedMessageData} from '@colonist/shared-types'

export class UIChatPost {
    static post(container: HTMLDivElement, chatData: FeedMessageData, preventScroll: boolean = false, makeSound: boolean = true): HTMLElement {
        const postController = new UIChatPostController(container, chatData)
        if(makeSound) AudioManager.play(AudioType.MessageNotification)
        if(!preventScroll) container.scrollTop = container.scrollHeight
        return postController.post
    }
}
